import {createClass} from "../../utils/helper";


export default function FillVatPopup({show = true,
                                         onHide = () => {},
                                         onClick = () => {},
                                         onInput = () => {},
                                         errorInput = false,
                                         taxId ="" ,
                                         eligible = true,
                                         styles= "block",
                                         translations,
                                         // visible =false,
                                         clicked = false,
                                         message1 ="",
                                         message2 ="",
                                         lang,tries,checkInput, isKsybError = false


                                     }) {
    return (
        <>
            <div className={createClass("wcs-form-wrapper wcs-visible", eligible ? "" : " wcs-err"  )} >
                <a  className={createClass("wcs-open-close  ",show ? "wcs-active" : "")} onClick={onHide}>open-close</a>
                <div className={createClass("wcs-form ",show ? "wcs-active" : "")}  style={  { display: styles } }>
                    <div className="wcs-title">
                        {translations['vat1']} <br/> {translations['vat2']}
                    </div>
                    <div className="wcs-text">
                        {translations['text1']} <br/>
                        {translations['text2']}
                    </div>

                    {!clicked &&
                        <>
                            <input type="number" min="0" max="999999999" value={taxId ? `${taxId}`: ""}
                                   className={createClass("wcs-field ", errorInput ? "wcs-error": "")} id="frm-vat"
                                   placeholder= {translations['vat']} onInput={(e)=>onInput(e.target.value)}
                                   onBlur={checkInput}/>
                            <a   className={createClass("wcs-submit ")} onClick={onClick} >
                                {translations['submit']}
                            </a>
                        </>
                    }
                    {clicked &&
                        <div className="wcs-redirect wcs-text" style={clicked ? { display: "block" } : { display: 'none' }} >{translations['please1']} <br/> {translations['please2']} </div>
                    }
                    <div className="wcs-redirect wcs-text" style={eligible && styles === 'none' ? { display: "block" } : { display: 'none' }}>{translations['please1']} <br/> {translations['please2']}</div>
                </div>
                <div className="wcs-results">
                    <div className="wcs-result" id="wcs-result3" style={!eligible ? { display: "block" } : { display: 'none' }} >
                        <div className="wcs-title">
                            {translations['invalidHeader']}
                        </div>
                        {tries && tries < 3 && isKsybError === false ? <>
                                <div className="wcs-text">
                                    {message1}<br/>
                                    {message2}<br/>
                                </div>
                                <div className={createClass("wcs-form wcs-active")}  >
                                    <input type="number" min="0" max="999999999" value={taxId ? `${taxId}`: ""}
                                           className={createClass("wcs-field ", errorInput ? "wcs-error": "")} id="frm-vat"
                                           placeholder= {translations['vat']} onInput={(e)=>onInput(e.target.value)}
                                           onBlur={checkInput}
                                    />
                                    <a   className={createClass("wcs-submit ")} onClick={onClick} >
                                        {translations['submit']}
                                    </a>
                                </div>
                            </>
                            :
                            <div className="wcs-text">
                                {translations['redirect']}
                            </div>
                        }

                        {/*<a  className="wcs-retry">*/}
                        {/*    Προσπάθησε ξανά*/}
                        {/*</a>*/}

                    </div>
                    <div className="wcs-result" id="wcs-result1" style={eligible && styles === 'none' ? { display: "block" } : { display: 'none' }}>
                        <div className="wcs-title">
                            {translations['eligibleHeader']}
                        </div>
                        <div className="wcs-redirect " style={eligible && styles === 'none' ? { display: "block" } : { display: 'none' }}>{translations['redirect']}</div>
                    </div>
                </div>
            </div>
        </>
    );
}
